import { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';
import type { SprintListItem } from '../../services/sprintService';

interface Props {
  count: number;
  sprints: SprintListItem[];
  onAssign: (sprintId: string) => void;
  onClear: () => void;
  isLoading: boolean;
}

export default function BulkAssignBar({
  count,
  sprints,
  onAssign,
  onClear,
  isLoading,
}: Props) {
  const [targetSprintId, setTargetSprintId] = useState('');

  const assignableSprints = sprints.filter(
    (s) => s.status === 'PLANNED' || s.status === 'ACTIVE',
  );

  const handleAssign = () => {
    if (!targetSprintId) return;
    onAssign(targetSprintId);
  };

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-3 bg-gray-900 text-white px-4 py-2.5 rounded-xl shadow-lg z-10">
      <span className="text-sm font-medium">{count}건 선택</span>

      <ArrowRight className="w-4 h-4 text-gray-400" />

      <select
        value={targetSprintId}
        onChange={(e) => setTargetSprintId(e.target.value)}
        className="text-sm bg-gray-800 border border-gray-700 rounded px-2 py-1 text-white focus:outline-none focus:ring-1 focus:ring-blue-400"
      >
        <option value="">스프린트 선택</option>
        {assignableSprints.map((s) => (
          <option key={s.sprintId} value={s.sprintId}>
            {s.name}
          </option>
        ))}
      </select>

      <button
        onClick={handleAssign}
        disabled={!targetSprintId || isLoading}
        className="text-sm px-3 py-1 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-700 disabled:text-gray-500 rounded transition-colors"
      >
        {isLoading ? '할당 중...' : '할당'}
      </button>

      <button
        onClick={onClear}
        className="p-1 text-gray-400 hover:text-white transition-colors"
        title="선택 해제"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
